import UserApi from '@/modules/core/api/user.api.ts';
import { defineStore } from 'pinia';
import { StoreId } from '@/modules/common/enums/store-id.enum.ts';
import type { NonNullableObject } from '@/modules/common/types/utils.ts';

type State = {
  id: number | null;
  name: string | null;
};

// TODO: Рефакторинг
export const useUserStore = defineStore(StoreId.User, {
  state: (): State => ({
    id: null,
    name: null,
  }),
  getters: {
    isDefined: (state) => state.id !== null && state.name !== null,
    required(state): NonNullableObject<State> {
      if (!state.id || !state.name) {
        throw new Error("The current user's data is not defined.");
      }

      return {
        id: state.id,
        name: state.name,
      };
    },
    initials(state) {
      if (!state.name) {
        return null;
      }

      return state.name
        .split(' ')
        .map((word) => word[0])
        .join('')
        .slice(0, 3)
        .toUpperCase();
    },
    shortName(state) {
      if (!state.name) {
        return null;
      }

      const words = state.name.split(' ');

      return words.length > 1
        ? `${words[0]} ${words
            .slice(1)
            .map((word) => word[0])
            .join('.')
            .toUpperCase()}.`
        : words[0];
    },
  },
  actions: {
    async fetch() {
      this.id = await UserApi.getId();
      this.name = await UserApi.getName(this.id);
    },
  },
  persist: true,
});
